import script from "./DialogText.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogText.vue?vue&type=script&setup=true&lang=js"

import "./DialogText.vue?vue&type=style&index=0&id=42c4c8d0&lang=css"

const __exports__ = script;

export default __exports__